export const templateMauKetQua = `
<h3>Gan</h3>
    <ul>
        <li>Kích thước: Bình thường</li>
        <li>Nhu mô: Đều</li>
        <li>Bờ: Đều</li>
        <li>Khối khu trú: Không có</li>
    </ul>
    <h3>Đường mật</h3>
    <ul>
        <li>Gan hai bên: Không giãn, không sỏi</li>
        <li>Ông mật chủ: Không giãn, không sỏi</li>
    </ul>
    <h3>Tĩnh mạch cửa</h3>
    <ul>
        <li>Giãn: Không</li>
        <li>Thành: Mỏng</li>
        <li>Huyết khối: Không có</li>
    </ul>
    <h3>Túi mật</h3>
    <ul>
        <li>Thành: Mỏng</li>
        <li>Dịch mật: Trong</li>
        <li>Sỏi: Không có</li>
    </ul>
    <h3>Tụy</h3>
    <ul>
        <li>Kích thước: Bình thường</li>
        <li>Ống tụy: Không giãn</li>
        <li>Khối khu trú: Không có</li>
        <li>Dịch quanh tụy: Không có</li>
    </ul>
    <h3>Lách</h3>
    <ul>
        <li>Kích thước: Bình thường</li>
        <li>Nhu mô: Đều</li>
        <li>Khối khu trú: Không có</li>
    </ul>
    <h3>Thận phải</h3>
    <ul>
        <li>Kích thước: Bình thường</li>
        <li>Nhu mô: Dày bình thường</li>
        <li>Đài bể thận: Không giãn</li>
        <li>Sỏi: Không có</li>
        <li>Niệu quản: Không giãn</li>
    </ul>
    <h3>Thận trái</h3>
    <ul>
        <li>Kích thước: Bình thường</li>
        <li>Nhu mô: Dày bình thường</li>
        <li>Đài bể thận: Không giãn</li>
        <li>Sỏi: Không có</li>
        <li>Niệu quản: Không giãn</li>
    </ul>
    <h3>Bàng quang</h3>
    <ul>
        <li>Thành: Mỏng</li>
        <li>Nước tiểu: Trong</li>
        <li>Sỏi: Không có</li>
    </ul>
    <h3>Tiền liệt tuyến</h3>
    <ul>
        <li>Kích thước: [Kích thước tiền liệt tuyến]</li>
        <li>Trọng lượng: [Trọng lượng tiền liệt tuyến]</li>
    </ul>
    <h3>Ổ bụng</h3>
    <ul>
        <li>Dịch tự do: Không có</li>
    </ul>
`